<div ngbDropdown #userDrop="ngbDropdown" placement="bottom-right bottom-left top-right bottom-left">
  <button ngbDropdownToggle class="btn user-button text-end">
    <div class="d-inline-flex align-items-center">
      <ng-container *ngIf="authService.user then userNameRole"></ng-container>
      <div class="ps-3">
        <fa-layers size="3x">
          <fa-icon [icon]="['fas', 'circle']"></fa-icon>
          <fa-layers-text [content]="firstInitial" [fixedWidth]="true" transform="shrink-10 up-2.2 left-1.5">
          </fa-layers-text>
          <fa-layers-text [content]="lastInitial" [fixedWidth]="true"
            transform="shrink-10 down-2 right-1.5"></fa-layers-text>
        </fa-layers>
      </div>
    </div>
  </button>
  <div ngbDropdownMenu class="w-100">
    <div class="d-flex d-md-none justify-content-end pt-0">
      <button class="user-button btn d-flex align-items-center text-end" (click)="userDrop.close()">
        <ng-container *ngIf="authService.user then userNameRole"></ng-container>
        <div class="ps-3">
          <fa-layers size="3x">
            <fa-icon class="icon-gray" [icon]="['fas', 'circle']"></fa-icon>
            <fa-icon [icon]="faTimes" [inverse]="true" transform="shrink-8"></fa-icon>
          </fa-layers>
        </div>
      </button>
    </div>
    <a ngbDropdownItem class="d-flex justify-controlesent-between mt-4 mt-md-0" routerLink="/profile">
      <div>My Profile</div>
      <fa-icon [icon]="faChevronRight" [fixedWidth]="true"></fa-icon>
    </a>

    <a *ngIf="isTicTenant() && (authService.isAdmin || (authService.isAgentAdmin && !authService.isAdmin))"
      ngbDropdownItem class="d-flex justify-content-between" routerLink="/admin">
      <div>Admin</div>
      <fa-icon [icon]="faChevronRight" [fixedWidth]="true"></fa-icon>
    </a>

    <!-- <a *ngIf="isTicTenant() && (authService.isAdmin || (authService.isAgentAdmin && !authService.isAdmin) || (authService.isInternal))"
      ngbDropdownItem class="d-flex justify-content-between" routerLink="/useradmin"> -->
  <a
  *ngIf="(
              authService.isAdmin
              || authService.isInternal
              || authService.isAgentAdmin
            )"
  ngbDropdownItem
  class="d-flex justify-content-between"
  [routerLink]="['/useradmin']">

  <div>User Administration</div>
  <fa-icon [icon]="faChevronRight" [fixedWidth]="true"></fa-icon>

</a>
     

    <div class="dropdown-item-text">
      <button class="btn d-block w-100 btn-round btn-brand-secondary fw-bold mt-4" (click)="logout()">
        <span class="h6">Sign Out</span>
      </button>
    </div>
  </div>
</div>
<ng-template #userNameRole>
  <div>
    <div class="fw-bold">
      {{ authService.user.given_name }} {{ authService.user.family_name }}
    </div>
    <div class="fw-light">
      <ng-container *ngFor="let role of authService.rolesAsDescriptions; index as i"><span *ngIf="i > 0">,</span>
        {{ role }}</ng-container>
    </div>
  </div>
</ng-template>